
'use strict';

module.exports = require('./js');



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/index.js
// module id = 2790
// module chunks = 1